// AIzaSyBXZdMpnHJ7R4aTufjgnFtis5mIAyxEP9U

// ajp-address-picker.js

(function () {

  function initMapAddressAutocomplete() {
    // Guard: ensure Google Places is available first
    if (!window.google || !google.maps || !google.maps.places) {
      return;
    }

    // Use data attribute so we don't rely on fixed IDs
    // IMPORTANT: initialise ALL matching inputs (Shopify can re-render sections)
    document.querySelectorAll('[data-ajp-address-search]').forEach(function (input) {
      // Prevent double init (safe to call init multiple times)
      if (input.dataset.ajpAutocompleteInit === '1') return;
      input.dataset.ajpAutocompleteInit = '1';

      // Read the per-block country mode from the data attribute
      var countryMode = input.getAttribute('data-ajp-country-mode') || 'uk';
      var countryCode = null;

      if (countryMode === 'uk') {
        countryCode = 'gb'; // Google uses 'gb' for United Kingdom
      } else if (countryMode === 'us') {
        countryCode = 'us';
      } else {
        countryCode = null; // 'any' or unknown → no restriction
      }

      var options = {
        types: ['geocode']
      };

      if (countryCode) {
        options.componentRestrictions = { country: countryCode };
      }

      var autocomplete = new google.maps.places.Autocomplete(input, options);

      //var autocomplete = new google.maps.places.Autocomplete(input, {
        //types: ['geocode'], // Addresses & locations
        // componentRestrictions: { country: 'gb' }, // uncomment for UK-only if you want
      //});

      // All address fields we want to clear
      var addressInputs = document.querySelectorAll('[data-ajp-address-line]');

      // Clear button (the X)
      var clearBtn = document.querySelector('.ajp-map-address-clear');

      // Helper: show/hide clear button
      function toggleClearButton() {
        var hasSearch = input.value.trim() !== '';
        var hasAddressValues = Array.prototype.some.call(addressInputs, function (el) {
          return el.value && el.value.trim() !== '';
        });

        if (clearBtn) {
          if (hasSearch || hasAddressValues) {
            clearBtn.hidden = false;
          } else {
            clearBtn.hidden = true;
          }
        }
      }

      autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();
        if (!place || !place.address_components) return;

        function getComponent(type) {
          var comp = place.address_components.find(function (c) {
            return c.types.indexOf(type) !== -1;
          });
          return comp ? comp.long_name : '';
        }

        var streetNumber = getComponent('street_number');
        var route = getComponent('route');
        var locality = getComponent('locality') || getComponent('postal_town');
        var postalCode = getComponent('postal_code');
        //var postalCode = ''; // DEBUG: Force missing postcode

        // If postal_code is missing, try extract UK postcode from formatted_address
        if (!postalCode && place && place.formatted_address) {
          var m = String(place.formatted_address).match(/\b([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})\b/i);
          if (m) {
            postalCode = m[1].toUpperCase().replace(/\s+/, ' ').trim();
          }
        }

        var country = getComponent('country');
        var adminArea = getComponent('administrative_area_level_1'); // county/region

        var postcodeUpper = (postalCode || '').toUpperCase();

        // Find the block wrapper that holds config
        var blockEl = input.closest('.ajp-map-address-search');
        var blockNI = blockEl?.getAttribute('data-ajp-block-ni') === 'true';
        var niErrorMessage =
          blockEl?.getAttribute('data-ajp-ni-error') ||
          'Sorry, we currently can’t create map puzzles for Northern Ireland addresses.';

        var errorEl = document.querySelector('.ajp-map-address-error');

        if (blockNI && postcodeUpper.startsWith('BT')) {
          // Show error
          if (errorEl) {
            errorEl.textContent = niErrorMessage;
            errorEl.hidden = false;
          }

          // Clear search field
          input.value = '';

          // Clear all populated address fields
          document
            .querySelectorAll('[data-ajp-address-line]')
            .forEach(function (el) {
              el.value = '';
            });

          toggleClearButton();
          input.focus();

          return; // 🚫 STOP – do not populate fields
        }

        // Clear error if valid address
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        //var line1 = (streetNumber + ' ' + route).trim();
        // Existing
        var line1 = (streetNumber + ' ' + route).trim();

        // Fallbacks for POIs / businesses where street_number/route may be missing
        if (!line1) {
          var premise = getComponent('premise');
          var poi = getComponent('point_of_interest') || getComponent('establishment');
          line1 = (premise || poi || '').trim();
        }

        // Fallback to place name (e.g. "Home Park") if still blank
        if (!line1 && place && place.name) {
          line1 = String(place.name).trim();
        }

        // Final fallback: first part of formatted_address (before first comma)
        if (!line1 && place && place.formatted_address) {
          line1 = String(place.formatted_address).split(',')[0].trim();
        }

        // Select the actual form fields via data attributes
        var line1Input = document.querySelector('[data-ajp-address-line="line1"]');
        var line2Input = document.querySelector('[data-ajp-address-line="line2"]');
        var townInput = document.querySelector('[data-ajp-address-line="town"]');
        var postcodeInput = document.querySelector('[data-ajp-address-line="postcode"]');
        var countyInput = document.querySelector('[data-ajp-address-line="county"]');
        var countryInput = document.querySelector('[data-ajp-address-line="country"]');

        if (line1Input) line1Input.value = line1;
        if (townInput) townInput.value = locality;
        if (postcodeInput) postcodeInput.value = postalCode;
        if (countyInput) countyInput.value = adminArea;
        if (countryInput) countryInput.value = country;

        // Clear line 2 (user can then add flat/apt)
        //if (line2Input) line2Input.value = '';
        // Populate line 2 when Google provides something useful (flat/unit/building/area)
        // Only fill if the field is currently empty so the customer can still type their own.
        var line2Candidate =
          getComponent('subpremise') ||              // Flat/Unit
          getComponent('premise') ||                 // Building name
          getComponent('neighborhood') ||            // e.g. Old Trafford (sometimes)
          getComponent('sublocality') ||
          getComponent('sublocality_level_1') ||
          '';

        if (line2Input) {
          if (!line2Input.value || !line2Input.value.trim()) {
            line2Input.value = line2Candidate;
          }
        }

        toggleClearButton();
      });

      // Listen to typing in the search input (to show/hide clear X)
      input.addEventListener('input', toggleClearButton);

      // Clear button click: wipe search + all address fields
      if (clearBtn) {
        clearBtn.addEventListener('click', function (event) {
          event.preventDefault();

          // Clear the search box
          input.value = '';

          // Clear all address fields populated via data-ajp-address-line
          addressInputs.forEach(function (el) {
            el.value = '';
          });

          toggleClearButton();
          input.focus();
        });
      }

      // Initial state
      toggleClearButton();
    });
  }

  // Expose to Google callback wrapper
  window.ajpInitMapAutocomplete = initMapAddressAutocomplete;

  // Re-run init safely (Shopify can re-render product sections without a full page load)
  document.addEventListener('DOMContentLoaded', initMapAddressAutocomplete);
  document.addEventListener('shopify:section:load', initMapAddressAutocomplete);
})();
